/**
 * State
 * Logged
 */
export interface State {
  logged: boolean;
}
export const initialState: State = {
  logged: false
};



// WEBPACK FOOTER //
// ./src/redux/logged/state.ts